// Shared queue config used by the public join page, the staff screen and the TV board.

// Stores that run a multi-floor layout show the Gold/Silver department step.
export const FLOOR_BRANCHES = ["TRUGANINA"];
export const isFloorBranch = (b) => FLOOR_BRANCHES.includes((b || "").toUpperCase());

export const DEPARTMENTS = [
  { key: "GOLD", label: "Gold", floor: "Ground floor" },
  { key: "SILVER", label: "Silver", floor: "First floor" },
];

export const deptLabel = (key) => {
  const d = DEPARTMENTS.find((x) => x.key === (key || "").toUpperCase());
  return d ? `${d.label} · ${d.floor}` : "";
};

const REASONS_DEFAULT = ["BUY", "SELL GOLD", "REPAIR", "COLLECTION", "ENQUIRY"];

const REASONS_BY_BRANCH = {
  TRUGANINA: [
    "BUY – GOLD JEWELLERY",
    "BUY – SILVER",
    "SELL GOLD",
    "REPAIR / ALTERATION",
    "ORDER PICKUP",
    "GOLD LOAN / FINANCE",
    "GENERAL ENQUIRY",
  ],
};

export const reasonsFor = (b) => REASONS_BY_BRANCH[(b || "").toUpperCase()] || REASONS_DEFAULT;

// Truganina runs two floors and each ticket is for ONE floor. These lists say which
// services each floor offers; shared services (repair, pickup, valuation, enquiry) are on both.
const FLOOR_SERVICES = {
  GOLD: [
    "BUY – GOLD JEWELLERY",
    "SELL GOLD",
    "GOLD LOAN / FINANCE",
    "REPAIR / ALTERATION",
    "ORDER PICKUP",
    "GENERAL ENQUIRY",
  ],
  SILVER: [
    "BUY – SILVER",
    "REPAIR / ALTERATION",
    "ORDER PICKUP",
    "GENERAL ENQUIRY",
  ],
};

// Services available on a given floor (department). Falls back to the full branch list when
// there is no floor (non-floor branches, or before a floor has been chosen).
export const reasonsForFloor = (b, dept) => {
  const all = reasonsFor(b);
  const allowed = isFloorBranch(b) && dept ? FLOOR_SERVICES[(dept || "").toUpperCase()] : null;
  return allowed ? all.filter((r) => allowed.includes(r)) : all;
};

// Services that are usually quick — staff can clear these fast to shrink the visible line.
export const QUICK_SERVICES = [
  "COLLECTION",
  "ORDER PICKUP",
  "ENQUIRY",
  "GENERAL ENQUIRY",
  "VALUATION / APPRAISAL",
];
export const isQuick = (reason) => QUICK_SERVICES.includes((reason || "").toUpperCase());

// "SELL GOLD" -> "Sell Gold"
export const labelCase = (r) =>
  (r || "").toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
